import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import styled from "styled-components";

import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import {
  downloadCsv,
  formatDate,
  getInvoiceId,
} from "../../../helperFunctions/utils";
import FilterComponent from "../../SharedComponents/FilterComponent";
import Filters from "./Filters";

const TableWrapper = styled.div`
  .rdt_TableCell > div {
    white-space: break-spaces;
  }
`;

export default function CustomizedPreviewTemplate({ id }) {
  const numberFormatter = Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const location = useLocation();
  const dispatch = useDispatch();
  const pathname = location.pathname;
  const fieldPathname = pathname.replace("/", "");

  const { tableSearch } = useSelector((state) => state.commonData);

  // let { id } = params;
  // let id = "6503f974aad8eb231d26baf1";
  const { previewTemplate } = useSelector((state) => state.templateData);

  const [previewTemplateData, setPreviewTemplateData] =
    useState(previewTemplate);
  const [templateTableData, setTemplateTableData] = useState([]);
  const [templateFilteredData, setTemplateFilteredData] = useState([]);
  const [templateTableColumns, setTemplateTableColumn] = useState([]);
  const [templateDetail, setTemplateDetail] = useState(null);
  const [filteredArray, setFilteredArray] = useState([]);
  const [conversionPayments, setConversionPayment] = useState([]);
  const [oriArray, setOriArray] = useState([]);
  const [model, setModel] = useState("");

  const [tableName, setTableName] = useState("Preview");
  const conditionalRowStyles = [
    {
      when: (row) => row,
      style: {
        borderWidth: "0px",
      },
    },
    {
      when: (row) => row.index % 2 === 1,
      style: {
        backgroundColor: "#f8f8f8",
        borderWidth: "0px",
      },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
  };

  let keys = _.union(
    ...previewTemplateData?.map((object) => Object.keys(object))
  );

  keys = keys?.filter((o) => o !== "_id");

  const columns = keys?.map((o) => {
    return {
      name: o,
      selector: (row) => row[o],
    };
  });

  const tableData = (
    filteredArray?.length > 0 ? filteredArray : previewTemplateData
  )?.map((o) => {
    let obj = {};
    Object.entries(o).forEach((item) => {
      obj = {
        ...obj,
        [item[0]]:
          typeof item[1] == "boolean"
            ? JSON.stringify(item[1])
            : JSON.stringify(item[1]),
      };
    });
    return obj;
  });

  const getStatusPayment = (o) => {
    const paidAmount =
      o?.paymentRecord && o?.paymentRecord?.length > 0
        ? o?.paymentRecord[o?.paymentRecord?.length - 1].payed
        : 0;
    const gstAmount = o?.gst;

    if (o?.isRefund) {
      if (o?.gst < 0) {
        return "Refund";
      } else if (o?.gst === 0) {
        return "Conversion";
      } else {
        return "Conversion Top Up";
      }
    }

    if (paidAmount < gstAmount && paidAmount !== 0) {
      return "Outstanding";
    }

    if (paidAmount > gstAmount) {
      return "Overpayment";
    }

    if (o?.isPaymentCompleted === true) {
      return "Paid";
    }

    return "Unpaid";
  };

    const formatSmart = (num) => {
      if (num === null || num === undefined || isNaN(num)) return 0;
      return Number(num) % 1 === 0 ? Number(num) : Number(num).toFixed(2);
    };

  const getLastPaidAmount = (originalInvoiceData) => {
    const paidAmount =
      originalInvoiceData?.paymentRecord &&
      originalInvoiceData?.paymentRecord?.length > 0
        ? originalInvoiceData?.paymentRecord[
            originalInvoiceData?.paymentRecord?.length - 1
          ].payed
        : 0;

    return paidAmount;
  };

  const getLastRemainingAmount = (originalInvoiceData) => {
    const remainingAmount =
      originalInvoiceData?.paymentRecord &&
      originalInvoiceData?.paymentRecord?.length > 0
        ? originalInvoiceData?.paymentRecord[
            originalInvoiceData?.paymentRecord?.length - 1
          ].remaining
        : 0;

    return remainingAmount;
  };

  const calcOustandingAmount = (e) => {
    const remainingAmount = getLastRemainingAmount(e);
    const linkedStatus = e?.linkedInvoice
      ? getStatusPayment({
          ...e?.linkedInvoice,
        })
      : "";

    if (e.linkedInvoice && linkedStatus === "Refund") {
      if (remainingAmount === 0) {
        return 0;
      }

      return (
        Number(remainingAmount === 0 ? e?.gst : remainingAmount) +
        Number(
          getLastPaidAmount(e?.linkedInvoice) -
            (Number(e?.linkedInvoice?.outstandingPaid) || 0)
        )
      );
    } else if (e.linkedInvoice && linkedStatus === "Conversion Top Up") {
      return (
        Number(remainingAmount === 0 ? e?.gst : remainingAmount) +
        Number(
          e?.linkedInvoice?.gst -
            (Number(getLastPaidAmount(e?.linkedInvoice)) || 0)
        )
      );
    }

    const payedAmount = Number(e.gst) - Number(getLastPaidAmount(e));
    return payedAmount ? payedAmount : 0;
  };

  const getTemplate = async (id) => {
    let query = {};

    if (id !== 0) {
      query.id = id;
    } else {
      if (!location?.state?.table_name) return;
      query.table_name = location?.state?.table_name;
      query.columns = location?.state?.columns;
    }
    const { result, error } = await authorizedRequests({
      url: `collections/templates-data/?query=${JSON.stringify(query)}`,
      method: "get",
    });
    if (error) {
      toastify(error?.message ?? "Unknown error occured", "error");
      return;
    }
    setTemplateTableColumn(
      id !== 0 ? result?.data?.template?.columns : location?.state?.columns
      //previous-code with filter  /// id != 0 ? result?.data?.template?.columns.filter((d) => d.filter === true) : location?.state?.columns
    );

    const tempData = result?.data?.table_data;
    setTemplateTableData([...tempData]);
    setConversionPayment(result?.data?.conversionPayments);
    setModel(result?.data?.template?.table_name);

    setTableName(result.data.template.name);
    setTemplateDetail(result.data.template);
    return result.data;
  };

  useEffect(() => {
    if (id) {
      fetchTemplateFunc();
    }
  }, [id, location?.state?.table_name]);

  const fetchTemplateFunc = async () => {
    setFilteredArray([]);
    setOriArray([]);
    setConversionPayment([]);
    await getTemplate(id);

    setTimeout(() => {
      if (
        tableSearch[fieldPathname] &&
        tableSearch[fieldPathname][id] &&
        tableSearch[fieldPathname][id]?.length > 0
      ) {
        const btnSearchEl = document.getElementById("btn-search-template");
        if (btnSearchEl) {
          btnSearchEl.click();
        }
      }
    }, 1000);
  };

  const table_columns = templateTableColumns?.map((o) => {
    if (
      o?.refColumn &&
      (o?.refColumn?.toLowerCase().includes("date") ||
        o?.refColumn?.toLowerCase() === "dob")
    ) {
      return {
        name: o.name,
        selector: (row) => formatDate(new Date(row[o?.column][o?.refColumn])),
      };
    }
    if (o.ref) {
      return {
        name: (() => {
          return (
            <div className="d-flex align-items-center" id="ovly2">
              <span className="me-2">{o.name}</span>
              <FilterComponent
                withRef={o.refColumn}
                isNested
                type="search"
                array={filteredArray}
                oriArray={oriArray}
                setArray={setFilteredArray}
                value={o.column}
              />
            </div>
          );
        })(),
        selector: (row) => {
          let value = row;
          if (o.column.includes(".")) {
            const key = o.column;
            const keys = key.split(".");

            keys.forEach((k) => {
              value = value[k];
            });
          } else {
            value = value[o.column];
          }

          if (Array.isArray(value)) {
            return (
              <>
                {value.length > 0 &&
                  value.map((k) => {
                    let refValue = k;
                    if (o?.refColumn?.includes(".")) {
                      const key = o.refColumn;
                      const keys = key.split(".");

                      keys.forEach((refKey) => {
                        refValue = refValue[refKey];
                      });
                    } else {
                      refValue = refValue[o.refColumn];
                    }
                    if (Array.isArray(refValue)) {
                      {
                        refValue?.length > 0 &&
                          refValue?.map((r) => {
                            return (
                              <div className="text-center">
                                {typeof refValue !== "string"
                                  ? JSON.stringify(refValue)
                                  : refValue}
                              </div>
                            );
                          });
                      }
                    } else {
                      if (o.refColumn === "invoiceNo") {
                        return (
                          <div className="text-center">
                            {getInvoiceId(refValue)}
                          </div>
                        );
                      }

                      return (
                        <div className="text-center">
                          {typeof refValue !== "string"
                            ? JSON.stringify(refValue)
                            : refValue}
                        </div>
                      );
                    }
                  })}
              </>
            );
          } else {
            let refValue = value;
            if (o?.refColumn?.includes(".")) {
              const key = o.refColumn;
              const keys = key.split(".");

              keys.forEach((refKey) => {
                refValue = refValue?.[refKey];
              });
            } else {
              refValue = refValue?.[o.refColumn];
            }
            if (Array.isArray(refValue)) {
              {
                refValue?.length > 0 &&
                  refValue?.map((r) => {
                    return (
                      <div className="text-center">
                        {typeof refValue !== "string"
                          ? JSON.stringify(refValue)
                          : refValue}
                      </div>
                    );
                  });
              }
            } else {
              return (
                <div className="text-center">
                  {typeof refValue !== "string"
                    ? JSON.stringify(refValue)
                    : refValue}
                </div>
              );
            }
          }
        },
        minWidth: "150px",
      };
    }
    if (
      o.column.toLowerCase().includes("date") ||
      o.column.toLowerCase().includes("lastpayment")
    ) {
      return {
        name: o.name,
        selector: (row) => formatDate(new Date(row[o.column])),
        minWidth: "150px",
      };
    }
    if (o.column.toLowerCase() === "paymentrecord") {
      return {
        name: o.name,
        selector: (row) => {
          if (o.item === "remaining" && row.conversionId) {
            const linkedInvoice = conversionPayments.find(
              (x) => x._id.toString() === row.conversionId
            );
            const oustandingPayment = calcOustandingAmount({
              ...row,
              linkedInvoice: linkedInvoice,
            });

            return oustandingPayment
              ? formatSmart(oustandingPayment)
              : 0;
          }

          if (row[o.column]?.length === 0) {
            return formatSmart(row.gst)
          }

          return row[o.column]?.length > 0
            ? formatSmart(row[o.column][row[o.column].length - 1]?.[o.item])
            : 0;
        },
        minWidth: "150px",
      };
    }
    if (
      (o.column === "actualAmount" ||
        o.column === "gst" ||
        o.column === "totalAmount") &&
      model === "payments"
    ) {
      return {
        name: o.name,
        selector: (row) => {
          if (o.column === "gst") {
            return numberFormatter.format(row.gst - row.actualAmount);
          }

          if (o.column === "totalAmount") {
            return row.gst;
          }

          return row.actualAmount;
        },
      };
    }
    if (o.column === "name") {
      return {
        name: o.name,
        selector: (row) => row[o.column],
        cell: (row) => (
          <div style={{ width: "100%", textAlign: "left", display: "block" }}>
            {typeof row[o.column] !== "string"
              ? JSON.stringify(row[o.column])
              : row[o.column]}
          </div>
        ),
        minWidth: "150px",
      };
    }
    if (o.column === "name" || o.column === "compTypesOfProducts") {
      return {
        name: o.name,
        selector: (row) => row[o.column],
        cell: (row) => (
          <div style={{ width: "100%", textAlign: "left", display: "block" }}>
            {row[o.column]}
          </div>
        ),
        minWidth: "150px",
      };
    }
    return {
      name: (
        <div className="d-flex align-items-center" id="ovly2">
          <span className="me-2">{o.name}</span>
          {!o.column.includes(".") ? (
            <FilterComponent
              dynamicFilter
              type="search"
              array={filteredArray}
              oriArray={oriArray}
              setArray={setFilteredArray}
              value={o.column}
            />
          ) : (
            <>
              <FilterComponent
                isNested
                dynamicFilter
                type="search"
                array={filteredArray}
                oriArray={oriArray}
                setArray={setFilteredArray}
                value={o.column}
              />
            </>
          )}
        </div>
      ),
      selector: (row) => {
        if (o.column.includes(".")) {
          const key = o.column;
          const keys = key.split(".");
          let value = row;

          keys?.forEach((k) => {
            if (value && k) {
              value = value[k] || null;
            }
          });
          if (Array.isArray(value)) {
            return (
              <>
                {value.length > 0 &&
                  value.map((k) => {
                    return (
                      <div className="text-center">
                        {typeof k !== "string" ? JSON.stringify(k) : k}
                      </div>
                    );
                  })}
              </>
            );
          }

          if (
            o.column.toLowerCase().includes("date") ||
            o.column.toLowerCase().includes("dob")
          ) {
            return formatDate(value);
          }

          return value;
        }

        if (o.column.includes("invoiceNo")) {
          return getInvoiceId(row[o.column]);
        }

        if (Array.isArray(row[o.column])) {
          let arrStr = "";
          row[o.column].map((itemValue, index) => {
            if (row[o.column].length - 1 === index) {
              arrStr += itemValue;
            } else {
              arrStr += `${itemValue}, `;
            }

            return false;
          });

          return arrStr;
        }

        return typeof row[o.column] !== "string"
          ? JSON.stringify(row[o.column])
          : row[o.column];
      },
      minWidth: "150px",
    };
  });

  useEffect(() => {
    if (
      location?.state?.startDate &&
      location?.state?.endDate &&
      templateTableData.length > 0
    ) {
      const tempArr = templateTableData.filter(
        (o) =>
          new Date(o.created_at).getTime() >
            location?.state?.startDate?.getTime() &&
          new Date(o.created_at)?.getTime() <
            location?.state?.endDate?.getTime()
      );
      setTemplateFilteredData([...tempArr]);
      setFilteredArray([...tempArr]);
      setOriArray([...tempArr]);
    } else {
      setTemplateFilteredData([...templateTableData]);
      setFilteredArray([...templateTableData]);
      setOriArray([...templateTableData]);
    }
  }, [location?.state?.startDate, location?.state?.endDate, templateTableData]);

  const handleExport = () => {
    const excelColumns = [];
    const excelRows = [];

    templateTableColumns.map((tbColumn) => {
      const columnName = tbColumn.name;
      let columnField = tbColumn.column;
      if (tbColumn.refColumn) {
        columnField += `.${tbColumn.refColumn}`;
      }

      excelColumns.push({
        name: columnName,
        field: columnField,
        isItem: tbColumn.isItem,
        item: tbColumn.item,
      });

      return false;
    });

    [...filteredArray].map((o) => {
      const dataRow = {};
      excelColumns.map((column) => {
        let columnValue = null;
        const splitField = column.field.split(".");
        splitField.map((field) => {
          if (columnValue === null) {
            if (column.isItem === true) {
              if (column.item === "remaining") {
                if (o.conversionId) {
                  const linkedInvoice = conversionPayments.find(
                    (x) => x._id.toString() === o?.conversionId
                  );
                  const oustandingPayment = calcOustandingAmount({
                    ...o,
                    linkedInvoice: linkedInvoice,
                  });
                  columnValue = oustandingPayment
                    ? formatSmart(oustandingPayment)
                    : 0;
                } else {
                  if (o[field]?.length === 0) {
                    columnValue = o.gst.toFixed(2);
                  } else {
                    columnValue =
                      o[field][o[field].length - 1][column.item].toFixed(2);
                  }
                }
              } else {
                columnValue = o[field][o[field].length - 1][column.item];
              }
            } else {
              columnValue = o[field];
            }
          } else {
            if (Array.isArray(columnValue)) {
              const refValues = [...columnValue];
              refValues.map((refValue, index) => {
                const indexValue =
                  refValues.length - 1 === index
                    ? refValue[field]
                    : `${refValue[field]} ,`;
                if (typeof indexValue === "object") {
                  if (columnValue[field]) {
                    columnValue = columnValue[field];
                  } else {
                    columnValue = refValue[field];
                  }
                } else {
                  if (index === 0) {
                    columnValue = indexValue;
                  } else {
                    columnValue += indexValue;
                  }
                }
                return false;
              });
            } else {
              columnValue = columnValue[field];
            }
          }

          return false;
        });

        if (
          column.name.toLowerCase().includes("date") ||
          column.name.toLowerCase().includes("last payment")
        ) {
          dataRow[`${column.name}`] = formatDate(columnValue);
        } else if (column.name.includes("Invoice No")) {
          dataRow[`${column.name}`] = getInvoiceId(columnValue);
        } else {
          dataRow[`${column.name}`] = columnValue;
        }
        return false;
      });

      excelRows.push(dataRow);
      return false;
    });

    downloadCsv(excelRows, `${tableName}`);
  };

  const renderFilteredArray = () => {
    if (templateDetail?.isOutstanding) {
      const copyFilteredArray = [...filteredArray];
      copyFilteredArray.map((copyData) => {
        const linkedInvoice = conversionPayments.find(
          (x) => x._id.toString() === copyData.conversionId
        );
        const oustandingPayment = calcOustandingAmount({
          ...copyData,
          linkedInvoice: linkedInvoice,
        });

        copyData.leftAmount = oustandingPayment
          ? formatSmart(oustandingPayment)
          : 0;
      });
      let x = copyFilteredArray.filter((x) => x.leftAmount > 0);
      console.log("filteredarray", x);
      return copyFilteredArray.filter((x) => x.leftAmount > 0);
    } else {
      return filteredArray;
    }
  };

  const templateFilterArray = renderFilteredArray();
  const totalGST = templateFilterArray?.reduce(
    (acc, curr) => acc + ((curr.gst || 0) - (curr.actualAmount || 0)),
    0
  );
  const totalAmount = templateFilterArray?.reduce(
    (acc, curr) => acc + (curr.gst || 0),
    0
  );
  const totalWithoutGST = templateFilterArray?.reduce(
    (acc, curr) => acc + (curr.actualAmount || 0),
    0
  );
  console.log("templateFilteredData", templateFilteredData);


  return (
    <>
      <div className="p-0">
        {/* <div className="mainHeading px-4">
          <h1>
            <i
              className="fa fa-arrow-left cursor-pointer"
              onClick={() => {
                if (id != 0) navigate(-1);
                navigate("/add-template", {
                  state: location.state,
                });
              }}
            />
            {tableName}
          </h1>
        </div> */}
        {/* <div className="mb-3 w-100 d-flex justify-content-between px-4">
          <Button
            className="addItem ms-auto"
            onClick={() => handleExport()}
          >
            Export
          </Button>
        </div> */}
        <Filters
          id={id}
          columns={templateTableColumns}
          model={model}
          array={templateFilteredData}
          templateDetail={templateDetail}
          setArray={setFilteredArray}
          filteredArray={filteredArray}
          handleExport={handleExport}
        />
        <TableWrapper>
          <DataTable
            columns={table_columns}
            customStyles={customStyles}
            // data={filteredArray}
            data={renderFilteredArray()}
            pagination
            conditionalRowStyles={conditionalRowStyles}
          />
        </TableWrapper>
        <div style={{ marginBottom: "20px" }}></div>
      </div>
      {templateDetail?.name == "GST Report" && (
        <div className="mt-3" style={{ marginBottom: "20px" }}>
          <p
            className="font-16 fw-bold"
            style={{ textDecoration: "underline" }}
          >
            SUMMARY
          </p>
          <div className="grid-summary font-16 fw-bold">
            <div>Amount</div>
            <div>:</div>
            <div className="text-right">
              ${numberFormatter.format(totalWithoutGST)}
            </div>

            <div>Amount GST</div>
            <div>:</div>
            <div className="text-right">
              ${numberFormatter.format(totalGST)}
            </div>

            <div>Total Amount</div>
            <div>:</div>
            <div className="text-right">
              ${numberFormatter.format(totalAmount)}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
